import { useEffect, useRef, useState } from "react";
import {
    Row,
    Col,
    Container, Modal,
    Nav,
    Tab,
    Button,
    Form
} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import "../../../dashboard/styles.css";
import { useNavigate } from 'react-router-dom';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Card from "../../../../components/Card";
import { getToken } from "../../../../utils/auth";
import moment from "moment";
import Sponsored from "../../Sponsored";
import s5 from "../../../../assets/images/page-img/s5.jpg";
import { CircularProgress } from "@mui/material";

import CreateQrcTab from "./CreateQrcTab";
import pdf from '../../../../assets/images/pdf.png'
import StepperCritical from "./StepperCritical1";
import { useTranslation } from "react-i18next";
import PaymentCheckoutCritical from "../../../../components/Payment/PaymentCheckoutCritical";
import TopupCheckout from "../../../../components/Payment/TopupCheckout";
import PaymentCheckoutCriticalSwitch from "../../../../components/Payment/PaymentCheckoutCriticalSwitch";
import { useUser } from "../../../../Context/UserContext";

const CriticalTabs = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    useEffect(() => {
        if (!getToken()) {
            navigate("/auth/sign-in")
        }
    }, []);
    const splitFileLink = (a) => {
        const x = a.split('_');
        const y = x[x.length - 1];
        return decodeURIComponent(y);
    }
    const [start, setStart] = useState(null);
    const [audioState, setAudioState] = useState(null);
    const [recordedBlob, setRecordedBlob] = useState(null);
  const [loading, setLoading] = useState(true);

  const defaultCurrency = "USD";
  const defaultSymbol = "$";
    const [selectedCurrency, setSelectedCurrency] = useState(
      localStorage.getItem("selectedCurrency") || defaultCurrency
    );
    const [currencySymbol, setCurrencySymbol] = useState(
      localStorage.getItem("currencySymbol") || defaultSymbol
    );
    const [show, setShow] = useState(false);
    const [desPage, setDesPage] = useState(null);
    const [conditionDescription, setConditionDescription] = useState(null);
    const [deviceCode, setDeviceCode] = useState(null);
    const [itemName, setItemName] = useState(null);
    const [itemDescription, setItemDescription] = useState(null);
    const [photos, setPhotos] = useState([]);
    const [category, setCategory] = useState(null);
    const [categoryId, setCategoryId] = useState(null);
    const [categoryIdForCondition, setCategoryIdForCondition] = useState(null);
    const [categoryDetails, setCategoryDetails] = useState(null);
    const [conditionName, setConditionName] = useState(null);
    const [description, setDescription] = useState(null);
    const [condition, setCondition] = useState(null);
    const [conditionId, setConditionId] = useState(null);
    const [mark, setMark] = useState(false);
    const [file, setFile] = useState(null);
    const [contactModal, setContactModal] = useState(null);
    const [adviceModal, setAdviceModal] = useState(null);
    const [advice, setAdvice] = useState(null);
    const [adviceText, setAdviceText] = useState(null);
    const [adviceFile, setAdviceFile] = useState(null);
    const [contactDetailsShow, setContactDetailsShow] = useState(null);
    const [emergencyContact, setEmergencyContact] = useState(null);
    const [emergencyContactDetails, setEmergencyContactDetails] = useState(null);
    const [emergencyContactId, setEmergencyContactId] = useState(null);
    const [audio, setAudio] = useState(null);
    const [contactPerson, setContactPerson] = useState({
        "firstName": "",
        "lastName": "",
        "email": "",
        "mobileCode": "+91",
        "mobile": "",
        "relationShip": "",
        // 'conditionId': conditionId
        'conditionId': ''
    }); 
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [adviceUploadedFiles, setAdviceUploadedFiles] = useState([]);
    const [previewUrl, setPreviewUrl] = useState([]);
    const [upcoming, setUpcoming] = useState([]);
    const [audioLoader, setAudioLoader] = useState(null);
    const [fileLoader, setFileLoader] = useState(null);
    const [user, setUser] = useState("");
    const [available, setAvailable] = useState("");
    const [tabChange, setTabChange] = useState("");
    // const [activeTab, setActiveTab] = useState("first");

  const { userData } = useUser();

    const location = useLocation();
    const getQueryParam = (param) => {
        const hashParams = new URLSearchParams(location.hash.split('?')[1]); // Extract query from hash
        return hashParams.get(param);
      };
      const tabParam = getQueryParam("tab");
      const tabMapping = {
        "1": "first",
        "2": "second",
      };
      const defaultTab = tabMapping[tabParam] || "first";
      const [activeTab, setActiveTab] = useState(defaultTab);
      const handleTabChangeMain = (selectedTab) => {
        setActiveTab(selectedTab);
        setTabChange(selectedTab)
      }
    //   useEffect(() => {
    //     setActiveTab(defaultTab); // Ensure state updates when URL changes
    //   }, [defaultTab]);

    useEffect(() => {
    const loadInitialData = async () => {
        setLoading(true);
        try {
            await Promise.all([
                fetchUserData(),
                topupAvailable(),
                handleDropdown() 
            ]);
        } catch (error) {
            console.error("Failed loading initial data:", error);
            toast.error("Failed to load initial data");
        } finally {
            setLoading(false);
        }
    };
    
    loadInitialData();
}, []);




    const fetchUserData = async () => {
      try {
        // setLoading(true); 

        const token = getToken();
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/user`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setUser(response?.data?.data);
      } catch (error) {
        console.error("Failed Fetching Details", error);
        throw error;
      }  
    //   finally {
    //     setLoading(false);
    //   }
    };
const [youtube, setYoutube] = useState("")
    const handleDropdown = async () => {
        try {
          const token = getToken();
          const response = await axios.get(
            `${process.env.REACT_APP_URL}/api/default-setting`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        //   console.log("youtube", response.data.data.isDefaultSettingsExist.tutorialLinkForCriticalD[0]);
        //   console.log("youtube1", response.data.data.isDefaultSettingsExist.tutorialLinkForLostAndFound[0]);
          setYoutube(response?.data?.data?.isDefaultSettingsExist?.tutorialLinkForCriticalD[0]);
        } catch (error) {
          console.error("Failed Fetching dropdown", error);
        }
      };
    useEffect(()=>{
      handleDropdown();
    },[]);
    const topupAvailable = async () => {
      try {
        const token = getToken();
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/plan/user/purchesed-plan?platform=critical-D`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setAvailable(response?.data?.data);
      } catch (error) {
        console.error("Failed Fetching Details", error);
      }
    };
    useEffect(() => {
        fetchUserData();
        topupAvailable();
    },[])

    const handleUpcoming = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/event/upcoming/all`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        // "Content-Type": "multipart/form-data"
                    },
                }
            );

            setUpcoming(response.data.data.allEvents);
        } catch (error) {
            console.log("Failed Fetching Upcoming Event", error);
        }
    };


    const handleGetAdvice = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/advice`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            }
            )
            setAdvice(response?.data?.data);
        } catch (error) {
            console.log("Failed Fetching advice", error);
        }
    }

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const dataToSent = {
                "categoryName": itemName,
                "categoryDescription": itemDescription,
            }
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/category`,
                dataToSent, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
            );
            toast.success(response?.data?.message);
            setItemName('');
            setItemDescription('');
            setShow(null);
            handleGetAllCategory();
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }

    }

    const handleConditionAdd = async (e) => {
        e.preventDefault();
        if (!categoryIdForCondition) {
            toast.error('No Category Selected!');
            return;
        }
        // if (file?.size > 625000 ) {
        //     toast.error('Entity is too large')
        //     return;
        //   };

        try {

            const dataToSent = {
                "conditionName": conditionName,
                "conditionDescription": description,
                "conditionDocuments": uploadedFiles,
                'categoryId': categoryIdForCondition
            }
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/condition`,
                dataToSent, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
            );
            toast.success(response?.data?.message);
            setConditionId(response?.data?.__id)
            setMark(null);
            setConditionName('');
            setDescription('');
            setFile('');
            handleGetAllConditions()
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }

    const handleGetAllCategory = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/category/all`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            }
            )
            setCategory(response?.data?.data);
        } catch (error) {
            console.log("Failed Fetching Posts", error);
        }
    }
    const handleGetCategoryDetails = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/category/${categoryId}`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            }
            )
            setCategoryDetails(response?.data?.data);
        } catch (error) {
            console.log("Failed Fetching Posts", error);
        }
    }
    const handleGetAllConditions = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/condition/all`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            }
            )
            setCondition(response?.data?.data);
        } catch (error) {
            console.log("Failed Fetching Conditions", error);
        }
    }
    // useEffect(() => {
    //     handleGetAllCategory();
    //     handleGetAllConditions();
    //     handleGetAllContacts();
    //     handleGetAdvice();
    //     handleUpcoming();
    // }, [])


    useEffect(() => {
    const loadResources = async () => {
        try {
            await Promise.all([
                handleGetAllCategory(),
                handleGetAllConditions(),
                handleGetAllContacts(),
                handleGetAdvice(),
                handleUpcoming()
            ]);
        } catch (error) {
            console.error("Failed loading resources:", error);
            toast.error("Failed to load some resources");
        }
    };
    
    loadResources();
}, []);





    // useEffect(() => {
    //     if (categoryId) {
    //         handleGetCategoryDetails();
    //     }
    // }, [categoryId])
    const [loadingCategoryDetails, setLoadingCategoryDetails] = useState(false);

useEffect(() => {
    const loadCategoryDetails = async () => {
        if (categoryId) {
            setLoadingCategoryDetails(true);
            try {
                await handleGetCategoryDetails();
            } catch (error) {
                console.error("Failed loading category details:", error);
            } finally {
                setLoadingCategoryDetails(false);
            }
        }
    };
    
    loadCategoryDetails();
}, [categoryId]);





    const handleSelect = () => {
        if (categoryIdForCondition === null) {
            toast.error('Please Select Category!');
            return;
        }
        setMark(true);
    }

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;
        setContactPerson(prevState => ({
            ...prevState,
            [name]: val
        }));
    };
    const handleContactAdd = async (e) => {
        e.preventDefault();
        try {

            const dataToSent = contactPerson
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/emergencyContact`,
                dataToSent, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
            );
            toast.success(response?.data?.message);
            setContactModal(null);
            handleGetAllContacts();
            setContactPerson({
                "firstName": "",
                "lastName": "",
                "email": "",
                "mobileCode": "",
                "mobile": "",
                "relationShip": "",
                "conditionId": ''
            })
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }

    const handleGetAllContacts = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/emergencyContact/all`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            }
            )
            setEmergencyContact(response?.data?.data);
        } catch (error) {
            console.log("Failed Fetching emergencyContact", error);
        }
    }
    const handleGetSingleContact = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/emergencyContact/${emergencyContactId}`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            }
            )
            setEmergencyContactDetails(response?.data?.data);
        } catch (error) {
            console.log("Failed Fetching emergencyContact", error);
        }
    }
    // useEffect(() => {
    //     handleGetSingleContact();
    // }, [emergencyContactId])

    useEffect(() => {
    const loadContactDetails = async () => {
        if (emergencyContactId) {  // ✅ Add guard
            try {
                await handleGetSingleContact();
            } catch (error) {
                console.error("Failed loading contact details:", error);
                toast.error("Failed to load contact details");
            }
        }
    };
    
    loadContactDetails();
}, [emergencyContactId]);








    const handleAudioFileUpload = async () => {
        try {
            setAudioLoader(true);
            const formData = new FormData();
            // uploaded.forEach((file) => {
            formData.append('voiceNote', recordedBlob, 'audio.wav')
            // })
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/voiceNote/upload`,
                formData, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data"
                }
            }
            );
            setRecordedBlob(null);
            toast.success(response?.data?.message)
            setAudioState(response?.data?.data);
        }
        catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setAudioLoader(false);
        }
    };
    // console.log('audioState', audioState);
    const handleAddAdvice = async (e) => {
        e.preventDefault();
        if (!adviceText) {
            toast.error('Please add advice');
            return;
        }
        try {
            const formData = {
                'adviceText': adviceText,
                'adviceDocuments': previewUrl,
                'adviceVoiceNoteLink': audioState,
            }
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/advice`,
                formData, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
            );

            toast.success(response?.data?.message);
            setAdviceModal(null);
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }
    const MAX_IMAGES = 4;

    const handleFileInputChange = async (event) => {
        const chosenFiles = Array.prototype.slice.call(event.target.files)
        const uploaded = [...photos];
        if (chosenFiles?.length > MAX_IMAGES) {
            toast.error(`You can only upload up to ${MAX_IMAGES} images.`);
            return;
        };
        chosenFiles.some((file) => {
            if (file?.size > 2097152) {
                toast.error('Entity is too large')
                return;
            };
            uploaded.push(file);
        })
        setPhotos(uploaded);
        try {
            const formData = new FormData();
            uploaded.forEach((file) => {
                formData.append('files', file)
            })
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
                formData, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data"
                }
            }
            );
            toast.success(response?.data?.message);
            setUploadedFiles(response?.data?.data);
        }
        catch (error) {
            toast.error(error?.response?.data?.message);
        }
    };
    const handleAdviceFileUpload = async (event) => {
        const chosenFiles = Array.prototype.slice.call(event.target.files)
        const uploaded = [...adviceUploadedFiles];
        if (chosenFiles?.length > MAX_IMAGES) {
            toast.error(`You can only upload up to ${MAX_IMAGES} images.`);
            return;
        };
        chosenFiles.some((file) => {
            if (file?.size > 2097152) {
                toast.error('Entity is too large')
                return;
            };
            uploaded.push(file);
        })
        setAdviceUploadedFiles(uploaded);
        try {
            setFileLoader(true);
            const formData = new FormData();
            uploaded.forEach((file) => {
                formData.append('files', file)
            })
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
                formData, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data"
                }
            }
            );
            toast.success(response?.data?.message);
            setPreviewUrl(response?.data?.data);
        }
        catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setFileLoader(false);
        }
    };

    const handleVisitCount = async () => {
        try {
            const token = getToken();
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/stats/module`,
                {
                    moduleType: "criticalD"
                }, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
            );
            // console.log('Critical D Count done', response.data);
            
        } catch (error) {
            console.error('Failed Visit count', error);
        }

    }
    // useEffect(()=>{
    //     handleVisitCount();
    // },[]);

    useEffect(() => {
    const trackVisit = async () => {
        try {
            await handleVisitCount();
        } catch (error) {
            // Silent fail for analytics
            console.error("Failed to track visit:", error);
        }
    };
    
    trackVisit();
}, []);






    // const handleTabChange = (selectedTab) => {
    //     console.log("Tab changed to:", selectedTab);
    //     setTabChange(selectedTab);
    // };
    // const handleTabChangeMain = (selectedTab) => {
    //     // console.log("Tab changed to:", selectedTab);
    //     setActiveTab(selectedTab);
    //     setTabChange(selectedTab);
    // };

    const styles = {
        loaderOverlay: {
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        },
      };
      
    return (
        <>
<Toaster position="top-right" reverseOrder={false}/>
{loading && (
          <div style={styles.loaderOverlay}>
            <CircularProgress style={{ color: "white" }} />
          </div>
        )}
<div id="content-page" className="content-page position-relative">
                <Container>
                    <Row>
                        <Col lg={8} className="row m-0 p-0 ">
                            <Tab.Container id="left-tabs-example" 
                            activeKey={activeTab} 
                            onSelect={handleTabChangeMain}>
                            <div>
        <div className="text-primary" style={{ fontWeight: "bold",  fontSize:"20px", display:"flex", justifyContent:"center" }}>
            {t('critical_d_qr_code')}
        </div>
        <div className="text-primary " style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px", marginBottom:"15px"}}>
            <div>
                {youtube && (
                <a className="text-primary" href={youtube} style={{  textDecoration: "none", display: "inline-flex", alignItems: "center" }}>
                    <img src="https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png" alt="YouTube Icon" style={{ width: "25px", height: "18px", marginInline: "5px" }} />
                    {t('watch_how_it_works')}
                </a>)}
            </div>
            <div style={{display:"flex"}} className="d-none d-lg-flex">
                <div >{user?.isEnrolledInCriticalD ?  <div style={{display:"flex", gap:"10px"}}><TopupCheckout selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/>  <PaymentCheckoutCriticalSwitch selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/></div>: <PaymentCheckoutCritical selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/>}</div>
            </div>
        </div>
        <div style={{display:"flex", justifyContent:"right", marginBottom:"10px"}} className="d-flex d-lg-none">
                <div >{user?.isEnrolledInCriticalD ?  <div style={{display:"flex", gap:"10px"}}><TopupCheckout selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/>  <PaymentCheckoutCriticalSwitch selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/></div>: <PaymentCheckoutCritical selectedCurrency={selectedCurrency} currencySymbol={currencySymbol}/>}</div>
            </div>
{!loading && user && !user.isEnrolledInCriticalD && (
  <span style={{ color: "red", fontWeight: "600", display:"flex", justifyContent:"right", marginTop:"-10px" }}>
    {t("purchasePlanBeforeActivity")}
  </span>
)}
    </div>    
                               <div className="p-0 mb-2">
                                    <div className="px-2">
                                        <div className="user-tabing">
                                            {/* <Nav
                                                as="ul"
                                                variant="pills"
                                                className="d-flex align-items-center justify-content-evenly profile-feed-items p-0 m-0"
                                            >
                                                <Nav.Item as="li" className=" col-6 col-sm-6 p-0 text-nowrap ">
                                                    <Nav.Link
                                                        href="#details-tab"
                                                        eventKey="first"
                                                        role="button"
                                                        className=" text-center "
                                                    >
                                                        {t('critical_d_settings')}
                                                    </Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item as="li" className="col-6 col-sm-6 p-0 text-nowrap">
                                                    <Nav.Link
                                                        href="#qrc-tab"
                                                        eventKey="second"
                                                        role="button"
                                                        className="text-center "
                                                    >
                                                        {t('critical_d_qrc')}
                                                    </Nav.Link>
                                                </Nav.Item>
                                            </Nav> */}
                                                           <Nav
                                              variant="pills"
                                              className="connection-tabs-nav p-0 m-0 round"
                                            >
                                              <Nav.Item as="li">
                                                <Nav.Link
                                                  className="text-center"
                                                   href="#details-tab"
                                                        eventKey="first"
                                                >
                                                   {t('critical_d_settings')}
                                                </Nav.Link>
                                              </Nav.Item>
                                            
                                              <Nav.Item as="li">
                                                <Nav.Link
                                                  className="text-center"
                                                 href="#qrc-tab"
                                                        eventKey="second"
                                                >
                                                 {t('critical_d_qrc')}
                                                </Nav.Link>
                                              </Nav.Item>
                                            </Nav>
                                        </div>
                                    </div>
                                </div>
                                {/* <Col sm={12}> */}
                                <Tab.Content className="forum-content">
                                    <Tab.Pane eventKey="first">
                                        <Col lg={12} className=" m-0 p-0">
                                            <Col sm={12}>
                                                <Card id="post-modal-data" className="card-block card-stretch card-height">
                                                    
                                                    <Card.Body><StepperCritical available={available} handleTabChangeMain={handleTabChangeMain}/></Card.Body>
                                                </Card>
                                            </Col>
                                        </Col>
 
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="second">
                                        <Col lg={12} className=" m-0 p-0">
                                            <Col sm={12}>
                                                <Card id="post-modal-data" className="card-block card-stretch card-height">
                                                    <CreateQrcTab
                                                        handleGetAdvice={handleGetAdvice}
                                                        conditionId={conditionId}
                                                        condition={condition}
                                                        category={category}
                                                        advice={advice}
                                                        emergencyContact={emergencyContact}
                                                        available={available}
                                                        tabChange={tabChange}
                                                        topupAvailable={topupAvailable}
                                                    />
                                                </Card>
                                            </Col>
                                        </Col>
                                    </Tab.Pane>
                                </Tab.Content>
                                {/* </Col> */}
                            </Tab.Container>
                            
                        </Col>
                        <Col lg={4}>
                            <Sponsored />
                            <Card className="d-none d-lg-flex">
                                <div className="card-header d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">{t('upcoming_events')}</h4>
                                    </div>

                                </div>
                                <Card.Body>
                                    <ul className="media-story list-inline m-0 p-0">
                                        {upcoming?.length === 0 ? (
                                            <li className="d-flexxs mb-4 align-items-center">
                                                <div className="stories-data ms-3">
                                                    <h5
                                                        className="mb-1"
                                                        style={{ fontWeight: "bold", color: "gray" }}
                                                    >
                                                        {t('no_upcoming_events')}
                                                    </h5>
                                                </div>
                                            </li>
                                        ) : (
                                            upcoming?.slice(0,3)?.map((data, index) => (
                                                <li key={index} className="d-flex mb-4 align-items-center" >
                                                                                                   <img src={data?.image || s5} alt="story1" className="rounded-circle img-fluid" style={{ width: '50px', height: '50px' }} />
                                                                                                   <div className="stories-data ms-3">
                                                                                                       <h5 className="mb-1 hover-blue-event" style={{ fontWeight: 'bold', textTransform: 'capitalize', cursor:"pointer" }} onClick={() => window.open(`https://demo.dirido.com/event/${data?._id}`, '_blank')}>{data?.title}</h5>
                                                                                                       <p className="mb-0">
                                                                                                           {moment(data?.startDate).format('MMMM Do YYYY, h:mm a')}
                                                                                                       </p>
                                                                                                       <p className="mb-0">
                                                                                                           {t('organized_by')}: {data?.userId?.firstName} {data?.userId?.lastName}
                                                                                                       </p>
                                                                                                   </div>
                                                                                               </li>
                                            ))
                                        )}
                                    </ul>
                                </Card.Body>
                            </Card>

                        </Col>
                    </Row>

                </Container>
            </div >

        </>
    )
}

export default CriticalTabs
